import React from "react";

import { useFormik } from "formik";
import * as Yup from "yup";

import { useDispatch, useSelector } from "react-redux";

import logo from "../../assets/images/logo.png";
import { Alert, Form, FormFeedback, Input, Label, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import Banner from "./AuthBanner";
import { registerUser } from "../../slices/auth/register/thunk";

const Register = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const loading = useSelector((state) => state.Register.loading);

  const error = useSelector((state) => state.Register.error);
  const errorMsg = useSelector((state) => state.Register.errorMsg);

  console.log("error", error, errorMsg);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      password: "",
      confirm_password: "",
    },

    validationSchema: Yup.object({
      first_name: Yup.string().required("First Name *"),
      last_name: Yup.string().required("Last Name *"),
      email: Yup.string().email("Invalid email format").required("Email *"),
      phone_number: Yup.string().required("Phone Number *"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password *"),
      confirm_password: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password *"),
    }),
    onSubmit: async (values) => {
      try {
        const response = await dispatch(registerUser(values));
        if (response) {
          const email = encodeURIComponent(values.email);
          navigate(`/verify-code?register=true&otp=null&email=${email}`);
        }
      } catch (error) {
        console.log("error", error);
      }
    },
  });

  document.title = "Login";

  return (
    <React.Fragment>
      <div className="loginPage">
        <Banner />
        <div className="loginWrapper">
          <div className="loginContent">
            <div className="headerText">
              <img
                loading="lazy"
                className="logoImage"
                src={logo}
                alt="Company logo"
              />
              <h1 className="welcomeBack">Create Account</h1>
              <p className="loginInstructions">
                Enter following details to create new account.
              </p>
            </div>
            <Form
              className="loginForm"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
              action="#"
            >
              {error && errorMsg && (
                <Alert fade={true} color="danger" className="text-center">
                  {errorMsg}
                </Alert>
              )}

              <div className="d-flex align-items-center gap-4">
                <div className="inputField">
                  <Label htmlFor="first_name" className="inputLabel">
                    First Name
                  </Label>

                  <Input
                    name="first_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.first_name}
                    className="form-control textInput"
                    type="text"
                    id="first_name"
                    placeholder="Enter your first name"
                    invalid={
                      validation.touched.first_name &&
                        validation.errors.first_name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.first_name &&
                    validation.errors.first_name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.first_name}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="inputField">
                  <Label htmlFor="last_name" className="inputLabel">
                    Last Name
                  </Label>

                  <Input
                    name="last_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.last_name}
                    className="form-control textInput"
                    type="text"
                    id="last_name"
                    placeholder="Enter your first name"
                    invalid={
                      validation.touched.last_name &&
                        validation.errors.last_name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.last_name &&
                    validation.errors.last_name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.last_name}
                    </FormFeedback>
                  ) : null}
                </div>
              </div>

              <div className="inputField">
                <Label htmlFor="email" className="inputLabel">
                  Email
                </Label>
                <Input
                  name="email"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email || ""}
                  className="form-control textInput"
                  type="email"
                  id="email"
                  placeholder="Enter your email"
                  invalid={
                    validation.touched.email && validation.errors.email
                      ? true
                      : false
                  }
                />
                {validation.touched.email && validation.errors.email ? (
                  <FormFeedback type="invalid">
                    {validation.errors.email}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="inputField">
                <Label htmlFor="phone_number" className="inputLabel">
                  Phone Number
                </Label>
                <Input
                  name="phone_number"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.phone_number || ""}
                  className="form-control textInput"
                  type="phone_number"
                  id="phone_number"
                  placeholder="Enter your phone_number"
                  invalid={
                    validation.touched.phone_number &&
                      validation.errors.phone_number
                      ? true
                      : false
                  }
                />
                {validation.touched.phone_number &&
                  validation.errors.phone_number ? (
                  <FormFeedback type="invalid">
                    {validation.errors.phone_number}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="inputField">
                <Label htmlFor="password" className="inputLabel">
                  Password
                </Label>
                <Input
                  name="password"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.password || ""}
                  className="form-control textInput"
                  type="password"
                  id="password"
                  placeholder="Enter your password"
                  invalid={
                    validation.touched.password && validation.errors.password
                      ? true
                      : false
                  }
                />
                {validation.touched.password && validation.errors.password ? (
                  <FormFeedback type="invalid">
                    {validation.errors.password}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="inputField">
                <Label htmlFor="confirm_password" className="inputLabel">
                  Confirm Password
                </Label>
                <Input
                  name="confirm_password"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.confirm_password || ""}
                  className="form-control textInput"
                  type="password"
                  id="confirm_password"
                  placeholder="Enter your confirm_password"
                  invalid={
                    validation.touched.confirm_password &&
                      validation.errors.confirm_password
                      ? true
                      : false
                  }
                />
                {validation.touched.confirm_password &&
                  validation.errors.confirm_password ? (
                  <FormFeedback type="invalid">
                    {validation.errors.confirm_password}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="formOptions mt-0">
                <label className="rememberMe mb-0">
                  <input type="checkbox" className="checkbox" />
                  <span>Remember me</span>
                </label>
              </div>
              <button type="submit" className="signInButton">
                {loading ? <Spinner /> : "Sign Up"}
              </button>
              <div className="d-flex align-items-center mx-auto mt-4 gap-1">
                <p className="signUpPrompt">Already have an account? </p>
                <p
                  className="cursor-pointer signUpText"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Sign In
                </p>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Register;
